import _ from 'lodash';
import React from 'react';
import Crud from '~/components/crud';
import useReports from '~/view-data/use-reports';
import { Container, FlexButton } from '~/views/reports/styles'; // Use FlexButton instead
import { FaArrowDown } from 'react-icons/fa'; // Import the downward arrow icon
import { useHistory } from 'react-router-dom'; // Import useHistory for navigation

const columns = [
  {
    name: 'Parceiro',
    selector: 'Parceiro',
    width: '230px', 
    cell: (row) => <strong>{_.get(row, 'Parceiro Nome')}</strong>,
  },
  {
    name: 'Cliente',
    selector: 'Cliente',
    width: '300px', 
    cell: (row) => _.get(row, 'Cliente Nome'),
  },
  {
    name: 'Cliente CNPJ/CPF',
    selector: 'Cliente CNPJ/CPF',
    width: '140px',
    format: (row) => _.get(row, 'Cliente CNPJ/CPF'),
  },
  {
    name: 'Atividade',
    selector: 'Atividade',
    width: '140px',
    cell: (row) => _.get(row, 'Atividade'),
  },
  {
    name: 'Município', 
    selector: 'Município',
    width: '190px',
    cell: (row) => _.get(row, 'Município', 'N/A'),
  },
  {
    name: 'Grupo',
    selector: 'Grupo',
    width: '150px', 
    cell: (row) => _.get(row, 'Grupo'),
  },
  {
    name: 'Status', 
    selector: 'Status',
    width: '90px',
    cell: (row) => _.get(row, 'Status', 'N/A'),
  },
  {
    name: 'Soluções',
    selector: 'Soluções',
    cell: (row) => {
      const status = _.get(row, 'Soluções (Status)', 'N/A'); 
      return <div className="wrap-text">{status}</div>; 
    },
  },
  {
    name: 'No. Contrato', 
    selector: 'No. Contrato',
    center: true,
    width: '100px',
    cell: (row) => {
      const value = _.get(row, 'Número contrato', 'N/A');
      return (
        <span
          style={{
            display: 'inline-block',
            maxWidth: '90px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            verticalAlign: 'middle',
            cursor: value !== 'N/A' ? 'pointer' : 'default',
          }}
          title={value}
        >
          {value}
        </span>
      );
    },
  },
  {
    name: 'L/C', 
    selector: 'L/C',
    center: true,
    width: '40px',
    cell: (row) => _.get(row, 'Empresa', 'N/A'),
  },
];

function Profile({ acls }) {
  const { state, actions } = useReports();
  const history = useHistory(); 

  const handleRowClick = (row) => {
    const contractId = row['Id do Contrato']; 
    if (contractId) {
      history.push(`/partners/addition-contract/${contractId}`); // Navigate to the contract details page
    } else {
      alert('Contrato não encontrado para esta linha.');
    }
  };

  const handleDownloadCSV = () => {
    const rows = state.data?.rows || [];
    if (rows.length === 0) {
      alert('Nenhum dado disponível para download.');
      return;
    }

    // Format the date columns before generating the CSV
    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const formattedRows = rows.map((row) => ({
      ...row,
      'Início Contrato': formatDate(row['Início Contrato']),
      'Início Faturamento': formatDate(row['Início Faturamento']),
    }));

    // Filter out the 'Id do Contrato' column before generating the CSV
    const filteredRows = formattedRows.map(({ 'Id do Contrato': _, ...rest }) => rest);

    // Generate CSV content with semicolon as the delimiter
    const headers = Object.keys(filteredRows[0]).join(';'); // Add headers
    const csvRows = filteredRows.map((row) =>
      Object.values(row)
        .map((value) => `"${String(value).replace(/"/g, '""')}"`) // Escape double quotes
        .join(';') // Use semicolon as the delimiter
    );
    const csvContent = [headers, ...csvRows].join('\n');

    // Add UTF-8 BOM to ensure correct encoding
    const bom = '\uFEFF';
    const csvWithBom = bom + csvContent;

    const now = new Date();
    const formattedDate = `${now.getFullYear().toString().slice(-2)}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
    const fileName = `Clientes_${formattedDate}.csv`;

    // Create a Blob and generate a download link
    const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    // Clean up the temporary link
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Container>
      <FlexButton onClick={handleDownloadCSV} title="Download CSV">
        <FaArrowDown size={20} /> {/* Use the downward arrow icon */}
      </FlexButton>
      <Crud
        columns={columns}
        formTitle={() => 'Lista de Parceiros e Clientes'}
        emptyText="Nenhum Parceiro/Cliente encontrado"
        data={state.data || {}} 
        tableLoading={state.loading}
        onChangePage={actions.pageChange}
        onRowClicked={handleRowClick} // Handle row click
        disableRowClick={false} // Enable row click
        hideAdd={true} 
      />
    </Container>
  );
}

export default Profile;
